<template>
  <el-row>
    <el-row class="BannerContWidth">
      <el-col :span="24">
        <el-col :span="16"
                :xs='24'>
          <div class="DetailsCont">
            <div class="DetailsIconCont">
              <div class="DetailsIconTextCont">
                <img :src="Game.logo_url">
                <!-- <div>
                <span>编辑推荐</span>
              </div> -->
              </div>
              <div class="ScoreContWidth">
                <div class="ScoreCont">
                  <div>
                    <p>{{Game.game_name}}</p>
                    <!-- 厂商 -->
                    <span>{{$t('product.firm')}}：{{Game.issuer}}</span>
                  </div>
                  <!-- <div class="Score">
                  7.5
                </div> -->
                </div>
                <!-- <div class="FollowCont">
                <div class="FollowColorBlue">关注</div>
                <div class="FollowColor"><span>988058</span>人安装 | <span>637774</span>人关注</div>
                <div class="FollowColorBlue">{{Game.updated_msg}}</div>
              </div> -->
                <div class="btn-box">
                  <div class="DownLoadCont">
                    <!-- 下载 -->
                    <el-dropdown trigger="click"
                                 @command="handleCommand">
                      <span class="el-dropdown-link">
                        <img src="../assets/images/product/download.svg">{{$t('product.download')}}
                      </span>
                      <el-dropdown-menu class="my-dropdown"
                                        slot="dropdown">
                        <el-dropdown-item v-if="Game.apple_url"
                                          command="apple_url"><img src="../assets/images/product/ios.svg">Apple store</el-dropdown-item>
                        <el-dropdown-item v-if="Game.google_url"
                                          command="google_url"><img src="../assets/images/product/android.svg">Google play</el-dropdown-item>
                        <el-dropdown-item v-if="Game.download_url"
                                          command="download_url"><img src="../assets/images/product/android.svg">Apk</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <!-- <div @click="DownLoad()">
                  <a target="_blank"
                     href=""><img src="../assets/images/product/download.svg">{{$t('product.download')}}</a>
                </div> -->
                  </div>
                  <!-- 充值 -->
                 <div v-if="Game.attr_web_map.depositUrl != false" class="DownLoadCont">
                    <div>
                      <a v-if="$store.state.token"
                         target="_blank"
                         :href="Game.attr_web_map.depositUrl+ '/?userToken=' + $store.state.token"><img src="../assets/images/product/chongzhi.svg">{{$t('product.recharge')}}</a>
                      <a v-else
                         target="_blank"
                         :href="Game.attr_web_map.depositUrl"><img src="../assets/images/product/chongzhi.svg">{{$t('product.recharge')}}</a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <el-row class="DetailsEvaluateCont">
            </el-row>

          </div>
          <QRCode class="hidden-sm-and-up"></QRCode>
          <div class="detailsInfo">
            <!-- 充值活动-->
            <div>
              <div class="TitleFont TitleMargin">{{$t('product.rechargeActivity')}}</div>
              <div class="BriefText">
                <div v-html="Game.recharge_activity"></div>
                <!-- <div class="BriefTextBtn">展开</div> -->
              </div>
            </div>
            <!-- 简介 -->
            <div>
              <div class="TitleFont TitleMargin">{{$t('product.introduction')}}</div>
              <div class="BriefText">
                <div v-html="Game.description"></div>
                <!-- <div class="BriefTextBtn">展开</div> -->
              </div>
            </div>
            <!-- 宣传视频/截图 -->
            <div>
              <div class="TitleFont">
                <!-- 预览 -->
                <div>{{$t('product.preview')}}</div>
              </div>
              <swiper v-if="showSwiper"
                      ref="mySwiper"
                      :options="swiperOption">
                <swiper-slide class="my-swiper-slide"
                              v-for="banner in banners"
                              :key="banner">
                  <video preload="auto"
                         v-if="banner.indexOf('mp4')!=-1"
                         controls="controls"
                         :src="banner">
                    Your browser does not support the video tag.
                  </video>
                  <img v-if="banner.indexOf('mp4')==-1"
                       :data-src="banner"
                       class="swiper-lazy">
                  <div class="swiper-lazy-preloader"></div>
                </swiper-slide>
                <!-- <div class="swiper-pagination"
                   slot="pagination"></div> -->
                <div class="swiper-scrollbar"
                     slot="scrollbar"></div>

                <div class="swiper-button-prev"
                     slot="button-prev"></div>
                <div class="swiper-button-next"
                     slot="button-next"></div>
              </swiper>
            </div>
            <!-- 最近更新 -->
            <div>
              <div class="IconRight">
                <div class="TitleFont TitleMargin">{{$t('product.recentUpdates')}}</div>
                <!-- <div class="HistoryCont">查看历史</div> -->
              </div>
              <div class="BriefText">
                <div v-html="Game.updated_msg"></div>
                <!-- <div class="BriefTextBtn">展开</div> -->
              </div>
            </div>
            <!-- 详细信息 -->
            <div>
              <div class="TitleFont TitleMargin">{{$t('product.information')}}</div>
              <div class="FileMessage">
                <div>
                  <!-- 文件大小 -->
                  <div class="FileMessageTitle">{{$t('product.fileSize')}}：</div>
                  <div class="FileMessageText">{{Game.file_size}}</div>
                </div>
                <div>
                  <!-- 当前版本 -->
                  <div class="FileMessageTitle">{{$t('product.version')}}：</div>
                  <div class="FileMessageText">{{Game.version_num}}</div>
                </div>
                <div>
                  <!-- 更新时间 -->
                  <div class="FileMessageTitle">{{$t('product.updateTime')}}：</div>
                  <div class="FileMessageText"
                       v-if="Game.update_time">{{Game.update_time.substring(0,10)}}</div>
                </div>
                <div>
                  <!-- 厂商 -->
                  <div class="FileMessageTitle">{{$t('product.firm')}}：</div>
                  <div class="FileMessageText">{{Game.issuer}}</div>
                </div>
              </div>
            </div>
          </div>

          </div>
        </el-col>
        <el-col :md="{span: 7,offset: 1}"
                :sm="{span: 8,offset: 0}"
                class="hidden-xs-only">
          <QRCode v-if="IsShow"></QRCode>
        </el-col>
      </el-col>
    </el-row>
    <foot></foot>
  </el-row>
</template>

<script>
// import VueScrollbar from 'vue2-scrollbar'
// import 'vue2-scrollbar/dist/style/vue2-scrollbar.css'
// import 'vue2-scrollbar/dist/style/app.css'
import 'element-ui/lib/theme-chalk/display.css'
import QRCode from '@/components/QRCode'
import foot from '@/components/foot'
export default {
  name: 'product',
  components: {
    QRCode,
    foot
    // VueScrollbar
  },
  data () {
    return {
      showSwiper: false,
      banners: [],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        scrollbar: {
          el: '.swiper-scrollbar',//滚动条
        },
        //autoHeight: true, //高度随内容变化
        spaceBetween: 10,
        freeMode: true,
        slidesPerView: 'auto',//根据slide的宽度自动调整展示数量。此时需要设置slide的宽度
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        lazy: {
          loadPrevNext: true,
        },
        // ...
      },
      IsShow: true,
      VideoChecked: false,
      Game: {
		  attr_web_map:{
			  depositUrl : false
		  }
	  },
      ScrollWidth: '',
      imgLength: 1
    }
  },
  created () {
    this.GameData()
    let screenWidth = document.body.clientWidth // body宽度
    let scrollWidth = window.innerWidth - document.body.clientWidth // 滚动条宽度
    if (screenWidth < 768) {
      this.IsShow = false
    } else {
      this.IsShow = true
    }
    window.onresize = () => {
      let screenWidth = document.body.clientWidth
      if (screenWidth + scrollWidth < 768) {
        this.IsShow = false
        //this.ScrollWidth = this.imgLength * 345 + 'px'//控制横向滑动宽度
      } else {
        this.IsShow = true
        //this.ScrollWidth = this.imgLength * 665 + 'px'//控制横向滑动宽度
      }
    }
  },
  computed: {

  },
  mounted () {
    // console.log('Current Swiper instance object', this.mySwiper)
    // this.mySwiper.slideTo(3, 1000, false)
  },
  methods: {
    handleCommand (command) {
      window.open(this.Game[command])
    },
    DownLoad () {
      window.open(this.Game.download_url)
    },
    GameData () {
		let that =this
      this.$axios.get(this.apiUrl.API.GetProductDetail, {
        params: {
          gameId: this.$route.query.id
        }
      })
        .then((res) => {
          if (res.data.data.preview_url) {
            res.data.data.preview_url = res.data.data.preview_url.split(',');
            this.banners = res.data.data.preview_url;
            // console.log(this.mySwiper.slideTo(3, 1000, false))
            // this.mySwiper.slideTo(0, 1000, false);
            this.showSwiper = true;
            this.imgLength = res.data.data.preview_url.length;
            // if (this.IsShow) {
            //   this.ScrollWidth = this.imgLength * 665 + 'px'
            //   //document.querySelector('.scroll-me').style.width = res.data.data.preview_url.length * 665 + 'px'//控制横向滑动宽度
            // } else {
            //   this.ScrollWidth = this.imgLength * 345 + 'px'
            //   //document.querySelector('.scroll-me').style.width = res.data.data.preview_url.length * 345 + 'px'//控制横向滑动宽度
            // }
          }
          this.Game = res.data.data
		  this.Game.attr_web_map = JSON.parse(this.Game.attr_web_map)
		  if(this.Game.attr_web_map.depositUrl == ""){
			  // 页面不展示外部充值按钮
			  this.Game.attr_web_map.depositUrl = false
		  }
        })
    },
    // 点击左右按钮，控制scrollLeft
    clickArrowLeft () {
      let scrollLeft = this.$refs['Scrollbar'].scrollAreaWidth
      if (this.IsShow) {
        this.$refs['Scrollbar'].scrollToX(this.$refs['Scrollbar'].left - 665)
      } else {
        this.$refs['Scrollbar'].scrollToX(this.$refs['Scrollbar'].left - 345)
      }
    },
    clickArrowRight () {
      console.log(this.$refs['Scrollbar'])
      let scrollLeft = this.$refs['Scrollbar'].scrollAreaWidth
      if (this.IsShow) {
        this.$refs['Scrollbar'].scrollToX(this.$refs['Scrollbar'].left + 665)
      } else {
        this.$refs['Scrollbar'].scrollToX(this.$refs['Scrollbar'].left + 345)
      }
    }
  },
  updated () { }
}
</script>
<style>
.popper__arrow {
  display: none !important;
}
</style>

<style scoped>
.swiper-lazy-preloader {
  display: none;
}
.my-swiper-slide {
  width: 500px;
}
.swiper-slide img,
.swiper-slide video {
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.clearfix {
  clear: both;
}

.BannerContWidth {
  width: 1040px;
  display: flex;
  margin: 0 auto;
}
.detailsInfo {
  border-radius: 3px;
  background: #fff;
  margin: 15px 0 0 0;
  padding: 10px 10px 20px 20px;
  overflow: hidden;
}
.DetailsCont {
  width: 100%;
  margin-top: 1.5rem;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
}
.DetailsEvaluateCont {
  line-height: 73px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
.DetailsEvaluateCont > div {
  text-align: center;
  border: 1px solid #ccc;
}
.DetailsEvaluateCont > div > span {
  margin-left: 5px;
  font-size: 12px;
}
.DetailsIconCont {
  padding: 1.5rem;
  display: flex;
  background: #fff;
  border-radius: 3px;
}
.DetailsIconTextCont {
  margin: 0 1.5rem 0 0;
  width: 14.16rem;
  height: 14.16rem;
}
.DetailsIconTextCont > img {
  width: 14.16rem;
  height: 14.16rem;
  border-radius: 2rem;
}
.DetailsIconTextCont > div {
  text-align: center;
  margin-bottom: 1.08rem;
}
.DetailsIconTextCont > div > span {
  color: #ff7473;
  padding: 5px 1.8rem;
  background: #b3eaf9;
  border-radius: 3rem;
}
.ScoreContWidth {
  width: 100%;
}
.ScoreCont {
  display: flex;
  justify-content: space-between;
}
.ScoreCont p {
  font-size: 2rem;
  margin-bottom: 5px;
}
.ScoreCont span {
  color: #ff7473;
}
.Score {
  width: 5.66rem;
  height: 5.66rem;
  border-radius: 50%;
  line-height: 5.66rem;
  text-align: center;
  color: white;
  font-size: 2rem;
  background: #ff7473;
  margin-bottom: 3rem;
  margin-right: 5px;
}
.FollowCont {
  display: flex;
}
.FollowCont > div {
  line-height: 2rem;
  margin-right: 1rem;
}
.FollowColorBlue {
  line-height: 2rem;
  color: #ff7473;
}
.FollowColor {
  color: #ccc;
}
.btn-box {
  display: flex;
  margin-top: 2rem;
}
.DownLoadCont {
  cursor: pointer;
  display: inline-block;
}
.DownLoadCont > div {
  background: #ff7473;
  color: white;
  width: 130px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-right: 1rem;
  border-radius: 5px;
  font-size: 16px;
}
.DownLoadCont > div > a,
.DownLoadCont > div > span {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  color: #fff;
}
.DownLoadCont > div > a > img {
  margin: 0 8px 0 0;
  width: 2rem;
}
.DownLoadCont > div > span > img {
  margin: 0 8px 0 0;
  width: 2rem;
}
/* 下拉 */
.my-dropdown {
  background: #fff;
  color: #fff;
  width: 130px;
  border: none;
  padding: 0;
  overflow: hidden;
  border: 1px solid #ff7473;
}
.my-dropdown div {
  display: none;
}
.my-dropdown li {
  padding: 0 10px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  color: #ff7473;
  border-top: 1px solid #ff7473;
}
.my-dropdown li:nth-child(1) {
  border: none;
}

.my-dropdown li:hover {
  background-color: #ecf5ff;
  color: #ff7473;
}
.my-dropdown li img {
  width: 2rem;
  height: 2rem;
  margin: 0 2px 0 0;
}

.TitleFont {
  font-size: 1.333rem;
  border-left: 0.5rem solid #ff7473;
  padding-left: 0.667rem;
  margin: 1.333rem 0 1.333rem 0.833rem;
  display: flex;
}
.TitleFont > div {
  margin-right: 1rem;
}
.TitleFontNumber {
  font-size: 1rem;
  color: #ff7473;
}
.VideoCont,
.VideoContWidth {
  display: -webkit-box;
  overflow-y: auto;
}
.VideoCont > div,
.VideoContWidth > div {
  display: -webkit-box;
  margin-right: 1rem;
}
.VideoCont img,
.VideoContWidth img {
  width: 100%;
}
.el-icon-upload2 {
  font-size: 14px;
  color: #ff7473;
  margin-top: 1.7rem;
}
.IconRight {
  display: flex;
  justify-content: space-between;
}
.VideoContWidth > div {
  width: 35rem;
}
.FindCont {
  width: 100%;
}
.FindCont > img {
  width: 100%;
  display: block;
}
.FindDetailsCont {
  width: 100%;
  background: white;
  display: flex;
  justify-content: space-between;
}
.FindDetails {
  display: flex;
  padding: 1rem 0;
  line-height: 2.333rem;
  padding-left: 0.833rem;
}
.FindDetails > img {
  width: 4.75rem;
  height: 4.75rem;
  margin-right: 1rem;
  border-radius: 1rem;
}
.BannerTextTitle {
  font-size: 1.333rem;
}
.BannerText {
  font-size: 1.167rem;
}
.SizeCol {
  color: #999;
}
.ScoreNumCont {
  text-align: right;
  padding-right: 0.833rem;
}
.ScoreNum {
  font-size: 1rem;
  color: #14b8c7;
  padding-top: 1.4rem;
}
.FindScore {
  padding-top: 0.4rem;
  font-size: 1.333rem;
  color: #14b8c7;
}
.TitleMargin {
  margin-left: 0.833rem;
  margin-right: 0.833rem;
}
.BriefText {
  border-bottom: 1px solid #ccc;
  padding-bottom: 1rem;
  margin: 0 0.833rem;
  line-height: 2rem;
  word-wrap: break-word;
  white-space: pre-wrap;
  text-align: justify;
}
.BriefTextBtn {
  margin-top: 0.5rem;
  display: block;
  text-align: center;
  margin-bottom: 1rem;
}
.HistoryCont {
  font-size: 1rem;
  color: #14b8c7;
  margin-top: 1.7rem;
  margin-right: 0.833rem;
}
.FileMessage {
  display: flex;
  justify-content: space-between;
  margin-left: 0.833rem;
  margin-right: 0.833rem;
}
.FileMessageTitle {
  font-weight: bold;
}
.FileMessageText {
  line-height: 3rem;
}
@media (max-width: 1200px) {
  .BannerContWidth {
    width: 88%;
  }
  .DownLoadCont > div {
    width: 65px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
  }
  .DetailsEvaluateCont {
    line-height: 50px;
  }
  .DetailsIconTextCont {
    width: 10rem;
    height: 10rem;
  }
  .DetailsIconTextCont > img {
    width: 10rem;
    height: 10rem;
  }
  .Score {
    width: 5rem;
    height: 5rem;
    line-height: 5rem;
    margin-bottom: 1rem;
  }
  .DownLoadCont > div > a > img {
    width: 2rem;
  }
}
@media (max-width: 992px) {
  .BannerContWidth {
    width: 84%;
  }
  .DetailsIconTextCont {
    width: 10rem;
    height: 10rem;
  }
  .DetailsIconTextCont > img {
    width: 10rem;
    height: 10rem;
  }
  .DownLoadCont > div > a > img {
    width: 2rem;
  }
  .FollowCont {
    flex-wrap: wrap;
  }
  .DownLoadCont > div {
    width: 65px;
    height: 20px;
    line-height: 20px;
  }
  .DownLoadCont > div > img {
    width: 1rem;
  }
  .Score {
    width: 4rem;
    height: 4rem;
    line-height: 4rem;
    margin-bottom: 2rem;
    font-size: 1.6rem;
  }
  .VideoCont > div {
    width: 85%;
  }
  .VideoContWidth > div {
    width: 75%;
  }
}
@media (max-width: 768px) {
  .BannerContWidth {
    width: 82%;
  }
  .DownLoadCont > div {
    width: 65px;
    height: 20px;
    line-height: 20px;
  }
  .Score {
    margin-bottom: 2rem;
  }
  .VideoCont > div {
    width: 80%;
  }
  .VideoContWidth > div {
    width: 70%;
  }
  .DownLoadCont > div > a > img {
    width: 1rem;
  }
  .DownLoadCont > div > span > img {
	margin: 0 2px 0 0;
    width: 1rem;
  }
  .kolom > img {
    width: 325px;
    height: 185px;
  }
  .kolom > video {
    width: 325px;
    height: 185px;
  }
}
@media (max-width: 576px) {
  .BannerContWidth {
    width: 90%;
  }
  .ScoreCont p {
    font-size: 1.4rem;
  }
  .DetailsEvaluateCont {
    line-height: 40px;
  }
  .DetailsIconTextCont {
    width: 8rem;
    height: 8rem;
  }
  .DetailsIconTextCont > img {
    width: 8rem;
    height: 8rem;
  }
  .DownLoadCont > div {
    width: 80px;
    height: 22px;
    line-height: 22px;
  }
  .VideoCont > div {
    width: 80%;
  }
  .VideoContWidth > div {
    width: 70%;
  }
  .Score {
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
    margin-bottom: 1rem;
    font-size: 1.4rem;
  }
  .my-swiper-slide {
    width: 300px;
  }
  .my-dropdown li {
    font-size: 12px;
    padding: 0 20px;
  }
  .my-dropdown li img {
    width: 1.5rem;
    height: 1.5rem;
  }
  .DownLoadCont > div > a,
  .DownLoadCont > div > span {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product.vue